class ringadjuster extends HTMLElement {
  constructor() {
    super();
    this.CreditCard();
    this.generatelines();
    this.convertToMM();
    this.NavLinks();
  }
  generatelines() {
    for (let i = 0; i < 50; i++) {
      let line = document.createElementNS("http://www.w3.org/2000/svg", "line");
      line.setAttribute("x1", i * 8);
      line.setAttribute("y1", "0");
      line.setAttribute("x2", i * 8);
      line.setAttribute("y2", "100%");
      line.setAttribute("class", "slant_lines");
      document.querySelector(".rign-adjuster__svg-vertical g").appendChild(line);
    }
    for (let i = 0; i < 250; i++) {
      let line = document.createElementNS("http://www.w3.org/2000/svg", "line");
      line.setAttribute("x1", "0");
      line.setAttribute("y1", i * 8);
      line.setAttribute("x2", "100%");
      line.setAttribute("y2", i * 8);
      line.setAttribute("class", "horizontal_lines");
      document.querySelector(".rign-adjuster__svg-horizontal g").appendChild(line);
    }
  }
  convertToMM() {
    const range = this.querySelector('.ring-adjuster__range');
    let sizeFinalize = this.querySelector('.ring-adjuster__size-cs span');
    range.addEventListener('input', (e) => {
      let circle = this.querySelector('.rign-adjuster__circle');
      let circleValue = this.querySelector('.rign-adjuster__circle-value');
      let Calulatedinch = this.scaledHeight / 2.1 / 25.4;
      let calculatedValues = (e.target.value * 0.2645833333);
      circle.style.width = Calulatedinch * calculatedValues + 'px'
      circle.style.height = Calulatedinch * calculatedValues + 'px'
      circleValue.textContent = calculatedValues.toFixed(2) + 'mm';
      let minimumValue = 50;
      let nearestLowerSize = null;

      let ringSizes = {
        "XS": '16mm',
        "S": "17.3mm",
        "M": "18.5mm",
        "L": "19.7",
        "XL": "21mm"
      };

      for (let size in ringSizes) {
        const sizeInMM = parseFloat(ringSizes[size]);
        const subtractedValue = sizeInMM - calculatedValues.toFixed(2);
        const absoluteResultValue = subtractedValue > 0 ? subtractedValue : subtractedValue * -1;

        if (absoluteResultValue < minimumValue) {
          minimumValue = absoluteResultValue; 
          nearestLowerSize = size;
        }
      }
      sizeFinalize.textContent = `${nearestLowerSize}`;

    });
  }
  CreditCard() {
    let cardRangeInput = this.querySelector('.calibration-card__range');
    let cardImage = this.querySelector('.calibration-card__ring-img');
    let CalbContainer = this.querySelector('.ring-adjuster__card-detect');
    cardRangeInput.addEventListener("input", (e) => {
      const value = e.target.value;
      const scale = 0.4 + ((1.2 - 0.4) / (cardRangeInput.max - cardRangeInput.min)) * value;
      const right = -320 + ((-610 - -420) / (cardRangeInput.max - cardRangeInput.min)) * value;
      cardImage.style.transform = `scale(${scale})`;
      cardImage.style.right = `${right}px`;
    });
    const submitBtn = this.querySelector(".calibration-card__btn");

    submitBtn.addEventListener("click", () => {
      const rect = cardImage.getBoundingClientRect();
      this.scaledHeight = rect.height;
      let RingContainer = this.querySelector('.ring-adjuster');
      CalbContainer.style.display = 'none';
      RingContainer.style.display = 'block';
    });

  }
  NavLinks() {
    let navbuttons = this.querySelector('.ring-adjuster__container-nav-back');
    let previousWindow = this.querySelector('.ring-adjuster__card-detect');
    let RingContainer = this.querySelector('.ring-adjuster');
    let mainShowButton = this.querySelector('.ring-adjuster__main-btn__show');
    let Goback = this.querySelector('.calibration-card__info-nav');
    let SubmitBtn = this.querySelector('.ring-card__submit-btn');
    SubmitBtn.addEventListener('click', () => {
      RingContainer.style.display = 'none';
    })
    Goback.addEventListener('click', () => {
      previousWindow.style.display = 'none';
    })
    mainShowButton.addEventListener('click', () => {
      previousWindow.style.display = 'block';
    })
    navbuttons.addEventListener('click', () => {
      RingContainer.style.display = 'none';
      previousWindow.style.display = 'block';
    })
  }
}
customElements.define('ring-adjuster', ringadjuster);